import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { Observable, of } from 'rxjs';
import { ChartDataContext, ChartDateRange } from '../../utils/chart.utils';
import { TransactionSummaryResponse, WeeklyTransactionSummaryResponse } from './chart.type';

@Injectable({
  providedIn: 'root',
})
export class ChartService {
  private baseUrl = '';
  constructor(private http: HttpClient, private configService: ConfigService) {
    this.configService.getApi('account_service').subscribe((response) => {
      this.baseUrl = response;
    });
  }
  public getTotalPaymentSpent(id: string, fromDate: string, ToDate: string, type: string) {
    return this.http.get<TransactionSummaryResponse[]>(
      `${this.baseUrl}/payments/${id}/transactions-summary?from=${fromDate}&to=${ToDate}&type=${type}`,
    );
  }

  public getChartDataByContext(
    context: ChartDataContext,
    accountId: string,
    startDate: string,
    endDate: string,
    xAxisRange: ChartDateRange,
  ): Observable<TransactionSummaryResponse[] | WeeklyTransactionSummaryResponse[]> {
    let type: 'month' | 'week' | 'day';
    switch (xAxisRange) {
      case ChartDateRange.YEAR:
        type = 'month';
        break;
      case ChartDateRange.MONTH_WEEKS:
        type = 'week';
        break;
      default:
        type = 'day';
    }

    switch (context) {
      case ChartDataContext.TOTAL_SPENDING:
        return this.getTotalPaymentSpent(accountId, startDate, endDate, type);

      default:
        return of([]);
    }
  }
}
